var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "b-collapse",
        {
          staticClass: "card filter-border calendar-visible",
          attrs: {
            animation: "slide",
            "aria-id": "filter-content",
            open: false,
          },
          scopedSlots: _vm._u([
            {
              key: "trigger",
              fn: function (props) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      class: props.open
                        ? "filter-border-header-open"
                        : "filter-border-header-close",
                      attrs: {
                        role: "button",
                        "aria-controls": "filter-content",
                      },
                    },
                    [
                      _c("p", { staticClass: "card-header-title" }, [
                        _vm._v("Filtros"),
                      ]),
                      _c(
                        "a",
                        { staticClass: "card-header-icon text-not-underline" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: props.open
                                ? "fas fa-angle-up"
                                : "fas fa-angle-down",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("div", { staticClass: "appraisal-filter-container is-fluid" }, [
            _c(
              "div",
              { staticClass: "container", attrs: { id: "filter-content" } },
              [
                _c(
                  "b-field",
                  {
                    staticClass: "m-4 p-2",
                    attrs: {
                      grouped: "",
                      "group-multiline": "",
                      position: "is-centered",
                      expanded: "",
                    },
                  },
                  [
                    _c(
                      "b-field",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          label: "Fecha",
                          "custom-class": "has-text-weight-normal",
                          expanded: "",
                        },
                      },
                      [
                        _c("b-datepicker", {
                          attrs: {
                            id: "appraisal-filter-fecha",
                            locale: "es-ES",
                            placeholder: "Clic para seleccionar",
                            icon: "calendar",
                            "icon-pack": "fa",
                            range: "",
                            size: "is-small",
                            "trap-focus": "",
                          },
                          on: { input: _vm.onChangeFecha },
                          model: {
                            value: _vm.filtroFecha,
                            callback: function ($$v) {
                              _vm.filtroFecha = $$v
                            },
                            expression: "filtroFecha",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          label: "Estado",
                          "custom-class": "has-text-weight-normal",
                          expanded: "",
                        },
                      },
                      [
                        _c("b-taginput", {
                          attrs: {
                            id: "appraisal-filter-estado",
                            data: _vm.statesOptions,
                            autocomplete: "",
                            "allow-new": false,
                            "open-on-focus": true,
                            field: "name",
                            icon: "label",
                            rounded: "",
                            size: "is-small",
                            "has-counter": false,
                          },
                          on: {
                            input: _vm.onChangeState,
                            typing: _vm.getFilteredStatesOptions,
                          },
                          model: {
                            value: _vm.statesSelected,
                            callback: function ($$v) {
                              _vm.statesSelected = $$v
                            },
                            expression: "statesSelected",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          id: "field-buyer",
                          label: "Comprador",
                          "custom-class": "has-text-weight-normal",
                          expanded: "",
                        },
                      },
                      [
                        _c("b-taginput", {
                          attrs: {
                            id: "appraisal-filter-client",
                            data: _vm.buyerOptions,
                            autocomplete: "",
                            "allow-new": false,
                            "open-on-focus": true,
                            field: "",
                            icon: "label",
                            rounded: "",
                            size: "is-small",
                            "has-counter": false,
                          },
                          on: {
                            input: _vm.onChangeBuyer,
                            typing: _vm.getFilteredBuyerOptions,
                          },
                          model: {
                            value: _vm.buyerSelected,
                            callback: function ($$v) {
                              _vm.buyerSelected = $$v
                            },
                            expression: "buyerSelected",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          label: "Tipo",
                          "custom-class": "has-text-weight-normal",
                          expanded: "",
                        },
                      },
                      [
                        _c("b-taginput", {
                          attrs: {
                            id: "appraisal-filter-sales-type",
                            data: _vm.typesOptions,
                            autocomplete: "",
                            "allow-new": false,
                            "open-on-focus": true,
                            field: "",
                            icon: "label",
                            rounded: "",
                            size: "is-small",
                            "has-counter": false,
                          },
                          on: {
                            input: _vm.onChangeTypes,
                            typing: _vm.getFilteredTypesOptions,
                          },
                          model: {
                            value: _vm.typesSelected,
                            callback: function ($$v) {
                              _vm.typesSelected = $$v
                            },
                            expression: "typesSelected",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          label: "Usuario",
                          "custom-class": "has-text-weight-normal",
                          expanded: "",
                        },
                      },
                      [
                        _c(
                          "b-checkbox",
                          {
                            attrs: {
                              id: "appraisal-filter-usuario",
                              "true-value": "Todos",
                              size: "is-small",
                              "false-value": "Yo",
                            },
                            on: { input: _vm.onChangeUsuario },
                            model: {
                              value: _vm.filtroUsuario,
                              callback: function ($$v) {
                                _vm.filtroUsuario = $$v
                              },
                              expression: "filtroUsuario",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.filtroUsuario) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }